module.exports = __webpack_public_path__ + "static/media/doc_gris.e492c02b.ico";